export const USER_REGISTER_SUCCESS = 'USER_REGISTER_SUCCESS';